





























import AbpBase from "@/lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '@/lib/util'
import {GetDicsByCode} from "@/api/systemBasic"
import {
    SaveAppoinment
} from "@/api/follow/followUpAppointment";
@Component({})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    form:any = {}
    title="";
    followUpContents: any[] = [];
    formSave:any = {}
    async created() {
        this.getSelects();
        if(this.data.saveType=="编辑"){
            this.title=this.data.Date+" "+this.data.PatientName+ "编辑";
            this.form = Object.assign({},this.data);
        }
        else if(this.data.saveType=="批量新增")
        {
            this.title=this.data.Date+"批量新增";
            this.form = this.data;
        }
        else
        {
            this.form = Object.assign({},this.data);
            this.formSave = this.data;
            this.title=this.data.Date+" "+this.data.PatientName+ "编辑";
        }
    }
    // 获取所有下拉
    async getSelects() {
       	let res = await GetDicsByCode({code: 'PD_Dic_Follow_Up_Appointment'})
        this.followUpContents = res.objects;
    }
    async save(){
        if(this.data.saveType=="编辑"){
            (this.$refs.form as any).validate(async (valid:boolean)=>{
                if(valid){
                    let res = await SaveAppoinment(this.form)
                    if(res.status==1){
                        this.$emit('input',false);
                        this.$emit('on-success')
                    }
                }
            })
        }
        else 
        {
            this.formSave.FollowUpContent = this.form.FollowUpContent;
            this.formSave.Note = this.form.Note;
            this.$Message.success("操作成功");
            this.$emit('input',false);
            this.$emit('on-success')
        }
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followUpAppointment/edit.vue